module.exports = __webpack_public_path__ + "img/woodBackground.9462a26b.jpeg";